import { useState } from 'react';
import { generatePath, useSearchParams } from 'react-router-dom';

import {
  FOOTBALL_PLAY_RIVALS_RIVALRIES,
  FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_ARENA,
  FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_BETWEEN_YOU,
  FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_MATCHES,
} from '@sorare/core/src/constants/__generated__/routes';
import { useTypedParams } from '@sorare/core/src/lib/routing';

import { ProfileLayout } from 'components/rivals/ProfileLayout';
import { RivalryGamesSelection } from 'components/rivals/RivalryGamesSelection';

import { LayoutParams } from './__generated__/routeParams';

const RivalsRivalriesSelectedUserSlugLayout = () => {
  const { selectedUserSlug } = useTypedParams<LayoutParams>();

  const [searchParams] = useSearchParams();
  const selectedDate = searchParams.get('selectedDate');
  const [opponentUserSlug, setOpponentUserSlug] = useState(
    selectedDate ? selectedUserSlug : null
  );
  return (
    <>
      <ProfileLayout
        selectedUserSlug={selectedUserSlug}
        arenaPath={generatePath(
          FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_ARENA,
          {
            selectedUserSlug,
          }
        )}
        matchesPath={generatePath(
          FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_MATCHES,
          {
            selectedUserSlug,
          }
        )}
        betweenYouPath={generatePath(
          FOOTBALL_PLAY_RIVALS_RIVALRIES_SELECTEDUSERSLUG_BETWEEN_YOU,
          {
            selectedUserSlug,
          }
        )}
        backPath={FOOTBALL_PLAY_RIVALS_RIVALRIES}
        onChallenge={() => setOpponentUserSlug(selectedUserSlug)}
      />
      {opponentUserSlug && (
        <RivalryGamesSelection
          opponentUserSlug={opponentUserSlug}
          open={!!opponentUserSlug}
          selectedDate={selectedDate}
          onClose={() => {
            setOpponentUserSlug(null);
          }}
        />
      )}
    </>
  );
};
export default RivalsRivalriesSelectedUserSlugLayout;
